export const ROLES = {
  STAFF: 'STAFF',
  MANAGER: 'MANAGER',
  ADMIN: 'ADMIN',
  SUPERUSER: 'SUPERUSER',
};

const ROLE_ORDER = {
  [ROLES.STAFF]: 1,
  [ROLES.MANAGER]: 2,
  [ROLES.ADMIN]: 3,
  [ROLES.SUPERUSER]: 4,
};

export const normalizeRole = (role) => (ROLE_ORDER[role] ? role : ROLES.STAFF);

export const hasRoleAccess = (role, requiredRole) =>
  ROLE_ORDER[normalizeRole(role)] >= ROLE_ORDER[requiredRole];
